export const fetchItems = async (searchParams: URLSearchParams): Promise<any> => {
  const url = new URL('/public/list', window.location.href);
  url.search = searchParams.toString();

  const response = await fetch(url, {
    headers: {Accept: "application/json"}
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return await response.json();
}